import React from 'react';
import { Grid, Box, Typography } from '@mui/material';
import { motion } from 'framer-motion';
import SectionWrapper from '../shared/SectionWrapper';
import StatCounter from '../shared/StatCounter';
import { stats } from '../../data/stats';

const ExpertiseSection: React.FC = () => (
  <SectionWrapper id="expertise" dark>
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6 }}
    >
      <Box sx={{ textAlign: 'center', mb: 10 }}>
        <Typography
          variant="h2"
          sx={{ fontWeight: 700, mb: 3, color: '#ffffff' }}
        >
          By The Numbers
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ maxWidth: 500, mx: 'auto' }}>
          ToStructure is built for production. One app, every database,
          every major AI provider — rigorously tested and ready to deploy.
        </Typography>
      </Box>
    </motion.div>

    <Grid container spacing={4}>
      {stats.map((stat) => (
        <Grid size={{ xs: 6, md: 3 }} key={stat.label}>
          <StatCounter value={stat.value} suffix={stat.suffix} label={stat.label} />
        </Grid>
      ))}
    </Grid>
  </SectionWrapper>
);

export default ExpertiseSection;
